import { call, put, take, takeEvery } from "redux-saga/effects";

// Category Redux States
import { CATEGORIES, GET_CATEGORIES, GET_SUBCATEGORIES } from "./actionTypes";
import {
  cateGoriesFail,
  cateGoriesSuccess,
  getCategoriesFail,
  getCategoriesSuccess,
  getSubCategoriesFail,
  getSubCategoriesSuccess,
} from "./actions";

import { getCategories, getNewcategories, getSubcategoriesApi } from "helpers/backend_helper";

function* fetchCategories({ payload }) {
  try {
    const response = yield call(getCategories, payload);

    if (response.status === "failure") {
      return yield put(getCategoriesFail(response.message));
    }

    yield put(getCategoriesSuccess(response));
  } catch (error) {
    yield put(getCategoriesFail(error));
  }
}

function* onGetNewCategories({ payload: { data, callback } }) {
  try {
    const response = yield call(getNewcategories, data);
    if (response.status === "failure") {
      return yield put(cateGoriesFail(response.message));
    }
    callback && callback(response);
    yield put(cateGoriesSuccess(response.data));
  } catch (error) {
    yield put(cateGoriesFail(""));
  }
}

function* onGetSubCategories({ payload: { data, callback } }) {
  try {
    const response = yield call(getSubcategoriesApi, data);
    if (response.status === "failure") {
      return yield put(getSubCategoriesFail(response.message));
    }
    callback && callback(response);
    yield put(getSubCategoriesSuccess(response.data));
  } catch (error) {
    yield put(getSubCategoriesFail(error));
  }
}

function* CategoriesSaga() {
  yield takeEvery(GET_CATEGORIES, fetchCategories);
  yield takeEvery(CATEGORIES, onGetNewCategories);
  yield takeEvery(GET_SUBCATEGORIES, onGetSubCategories);
}

export default CategoriesSaga;
